(function () {

window.updateCartProgressBar = function (itemCount, cartTotal) {
  const fill = document.getElementById('cpb-fill');
  const message = document.getElementById('cpb-message');

  const msShip = document.getElementById('milestone-shipping');
  const ms10 = document.getElementById('milestone-10');
  const ms15 = document.getElementById('milestone-15');
  const ms20 = document.getElementById('milestone-20');

  if (!fill || !message) return;

  // ====== 阶梯金额 ======
  const FREE = 4900;   // $49
  const OFF10 = 7000;  // $70
  const OFF15 = 10500; // $105
  const OFF20 = 13900; // $139

  // ====== 进度 ======
  const progress = Math.min((cartTotal / OFF20) * 100, 100);
  fill.style.width = progress + '%';

  // ====== milestone ======
  msShip?.classList.toggle('is-reached', cartTotal >= FREE);
  ms10?.classList.toggle('is-reached', cartTotal >= OFF10);
  ms15?.classList.toggle('is-reached', cartTotal >= OFF15);
  ms20?.classList.toggle('is-reached', cartTotal >= OFF20);

  // ====== 文案 ======
  let html = '';

  if (cartTotal < FREE) {

    const remaining = ((FREE - cartTotal) / 100).toFixed(2);

    html = `
      You're <strong>$${remaining}</strong> away from
      <strong>Free Shipping</strong>.
    `;

  } else if (cartTotal < OFF10) {

    const remaining = ((OFF10 - cartTotal) / 100).toFixed(2);

    html = `
      <strong>Free Shipping</strong> unlocked.
      Add <strong>$${remaining}</strong> more to unlock
      <strong>10% Off</strong>.
    `;

  } else if (cartTotal < OFF15) {

    const remaining = ((OFF15 - cartTotal) / 100).toFixed(2);

    html = `
      <strong>10% Off</strong> unlocked.
      Add <strong>$${remaining}</strong> more to unlock
      <strong>15% Off</strong>.
    `;

  } else if (cartTotal < OFF20) {

    const remaining = ((OFF20 - cartTotal) / 100).toFixed(2);

    html = `
      <strong>15% Off</strong> unlocked.
      Add <strong>$${remaining}</strong> more to unlock
      <strong>20% Off</strong>.
    `;

  } else {

    html = `
      <strong>20% Off</strong> unlocked.
      <strong>Free Shipping</strong> unlocked.
    `;
  }

  // ====== 动画 ======
  message.style.opacity = '0';

  setTimeout(() => {
    message.innerHTML = html;
    message.style.opacity = '1';
  }, 200);
};


  // ====== API 刷新 ======
  function refreshCartData() {
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(res => res.json())
      .then(cart => {

        let originalTotal = 0;

        cart.items.forEach(item => {
          originalTotal += item.original_line_price;
        });

        window.updateCartProgressBar(cart.item_count, originalTotal);

      })
      .catch(console.error);
  }


  // ====== 拦截购物车请求 ======
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {

      const url = response.url || '';

      if (
        url.includes('/cart/add') ||
        url.includes('/cart/update') ||
        url.includes('/cart/change') ||
        url.includes('/cart/clear')
      ) {
        setTimeout(refreshCartData, 300);
      }

      return response;
    });
  };


  // ====== 初始加载 ======
  document.addEventListener('DOMContentLoaded', refreshCartData);

})();